import { memo } from 'motion-utils';
import { isHTMLElement } from '../../../utils/is-html-element.mjs';
/**
 * A list of values that can be hardware-accelerated.
 */

var acceleratedValues = new Set(["opacity", "clipPath", "filter", "transform" // TODO: Could be re-enabled now we have support for linear() easing
// "background-color"
]);
var supportsWaapi = /*@__PURE__*/memo(function () {
  return Object.hasOwnProperty.call(Element.prototype, "animate");
});

function supportsBrowserAnimation(options) {
  var _motionValue$owner;

  var motionValue = options.motionValue,
      name = options.name,
      repeatDelay = options.repeatDelay,
      repeatType = options.repeatType,
      damping = options.damping,
      type = options.type;

  if (!isHTMLElement(motionValue === null || motionValue === void 0 ? void 0 : (_motionValue$owner = motionValue.owner) === null || _motionValue$owner === void 0 ? void 0 : _motionValue$owner.current)) {
    return false;
  }

  var _motionValue$owner$ge = motionValue.owner.getProps(),
      onUpdate = _motionValue$owner$ge.onUpdate,
      transformTemplate = _motionValue$owner$ge.transformTemplate;

  return supportsWaapi() && name && acceleratedValues.has(name) && (name !== "transform" || !transformTemplate) &&
  /**
   * If we're outputting values to onUpdate then we can't use WAAPI as there's
   * no way to read the value from WAAPI every frame.
   */
  !onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
}

export { supportsBrowserAnimation };